//////// GHG 1.2 EF
const oneTwoSchema = {
  title: "1.2 Direct Emissions from Mobile Combustion",
  cat: "1_2",
  catName: "cat1",
  progressiveOrderSwitch: {
    by: { level: 4, key: "computationMethod" }, // 觀察誰
  },
  fields: [
    {
      key: "title",
      type: "title",
      title: "Emission Factor",
    },
    ////////Data Source (emissionFactorTypeId)
    {
      key: "emissionFactorTypeId",
      level: 3,
      type: "select",
      label: "Data Source",
      optionsAPI: "emissionFactorDropdown",
      autoFillNum: 0,
    },
    ////////Computation Method
    {
      key: "computationMethod",
      level: 4,
      type: "select",
      label: "Computation Method",
      optionsAPI: "emissionLevel",
      showIf: {
        level: 3,
        key: "emissionFactorTypeId",
        ne: "2",
      },
      combineKey: 1,
    },
    ////////Emission Factor Database Source (sourceEFName)
    {
      key: "sourceEFName",
      level: 5,
      type: "select",
      label: "Emission Factor Database Source",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 4,
        key: "computationMethod",
      },
      showIf: {
        level: 4,
        key: "computationMethod",
        notEmpty: true,
      },
      combineKey: 2,
    },
    ////////Fuel Type
    {
      key: "fuelType1_2",
      level: 6,
      type: "select",
      label: "Fuel Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 4, key: "computationMethod", ne: "Distance Based" },
          { level: 5, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    ////////Emission Factor Name (emissionFactorId)
    {
      key: "emissionFactorId",
      level: 8,
      type: "select",
      label: "Fuel Name",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "fuelType1_2",
      },
      showIf: {
        all: [
          { level: 4, key: "computationMethod", ne: "Distance Based" },
          { level: 6, key: "fuelType1_2", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    ////////Transport Model (transportId)
    {
      key: "transportModel",
      level: 6,
      type: "select",
      label: "Transport Model",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 5,
        key: "sourceEFName",
      },
      showIf: {
        all: [
          { level: 4, key: "computationMethod", ne: "Fuel Based" },
          { level: 5, key: "sourceEFName", notEmpty: true },
        ],
      },
      combineKey: 3,
    },
    ////////Vehicle Category (vehicleId)
    {
      key: "vehicleCategory",
      level: 7,
      type: "select",
      label: "Vehicle Category",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 6,
        key: "transportModel",
      },
      showIf: {
        all: [
          { level: 4, key: "computationMethod", ne: "Fuel Based" },
          { level: 6, key: "transportModel", notEmpty: true },
        ],
      },
      combineKey: 4,
    },
    ////////Vehicle Type (vehicleTypeId)
    {
      key: "emissionFactorId",
      level: 8,
      type: "select",
      label: "Vehicle Type",
      optionsAPI: "emissionLevel",
      optionsParamFrom: {
        level: 7,
        key: "vehicleCategory",
      },
      showIf: {
        all: [
          { level: 4, key: "computationMethod", ne: "Fuel Based" },
          { level: 7, key: "vehicleCategory", notEmpty: true },
        ],
      },
      combineKey: 5,
    },
    ////////Emission Factor Name (自定義)
    {
      key: "emissionFactorId",
      addBtn: true,
      level: 8,
      type: "select",
      custom: true,
      label: "Emission Factor Name",
      optionsAPI: "cat1CustomEFDropdownList",
      showIf: {
        level: 3,
        key: "emissionFactorTypeId",
        eq: "2",
      },
      autoFillNum: 0,
    },
  ],
};

export default oneTwoSchema;
